import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import Button from "@material-ui/core/Button";
import withModal from "../withModal";

interface IModelInvalidLink3P {
    isOpen: boolean;
    modalProps: {
        supportEmailAddress: string;
    };
}

const ModelInvalidLink3P: React.FC<IModelInvalidLink3P> = ({ isOpen, modalProps }: IModelInvalidLink3P) => {
    const dispatch = useDispatch();
    const hide = () => dispatch(hideModal("MODEL_INVALID_LINK_3P"));

    const emailLink = <a href={`mailto:${modalProps.supportEmailAddress}`}>{modalProps.supportEmailAddress}</a>;

    const customFooter = (
        <Button variant="contained" color="primary" onClick={hide} style={{ margin: "3px" }}>
            OK
        </Button>
    );

    return (
        <MaterialModal
            title="Model Link Not Allowed"
            isOpen={isOpen}
            onClose={() => hide()}
            id="model-thirdparty"
            maxWidth="lg"
            showPrimaryButton={false}
            footer={customFooter}
            disableEscape={true}
        >
            <div>
                <span style={{ fontSize: "18px" }}>
                    We cannot provide modeled data for Partner Audiences.
                    <br />
                    <br />
                    Please remove any Partner Audience data within your audience to use the Model node.
                    <br />
                    <br />
                    Please reach out to {emailLink} if you have any questions.
                </span>
            </div>
        </MaterialModal>
    );
};

export default withModal(ModelInvalidLink3P, "MODEL_INVALID_LINK_3P");
